import { ksSetup, KsToast, KsTooltip } from '@aschehoug/kloss'

export default defineNuxtPlugin((nuxtApp) => {
  const { vueApp } = nuxtApp

  vueApp.use(KsToast, { duration: 3000 })
  vueApp.directive('ks-tooltip', KsTooltip)
  ksSetup()
})
